module.exports = __webpack_public_path__ + "img/pphz.936d6c19.png";